import webAnalyticsLight from "../../../../contents/images/docs/web-analytics/web-analytics-light-mode.png";
import webAnalyticsDark from "../../../../contents/images/docs/web-analytics/web-analytics-dark-mode.png";
import webAnalyticsVideoLight from "../../../../contents/images/docs/web-analytics/web-analytics-light-mode.mp4";
import webAnalyticsVideoDark from "../../../../contents/images/docs/web-analytics/web-analytics-dark-mode.mp4";
import * as React from 'react';
export default {
  webAnalyticsLight,
  webAnalyticsDark,
  webAnalyticsVideoLight,
  webAnalyticsVideoDark,
  React
};